<template>
  <div class="full-block">
    <div class="container">
      <div class="row">
        <div v-for="(post, index) in posts" :key="index" class="col-12 col-md-6 col-lg-4 card-item">
          <div class="card">
            <img :src="post.img" class="card-img-top" />
            <div class="card-body">
              <h4 class="card-title">{{ post.title }}</h4>
              <p class="card-text">{{ post.desc }}</p>
              <div class="blog-category">
                <div class="blog-category-item">{{ getFormatDate(post.published_date) }} | {{ post.categories ? post.categories.join(', ') : '' }}</div>
                <div class="blog-category-icon"><font-awesome-icon :icon="['fas', 'eye']" /> {{post.views ? post.views : 0}}</div>
              </div>
            </div>
            <router-link type="link" :to="`/blog/${post.slug}`" :addClass="['small_link']">&nbsp;</router-link>
          </div>
        </div>
      </div>
      <div class="text-center blog-button mt-5">
        <app-button type="btn" :addClass="['btn', 'btn-primary']" :action="loadMore">Load more</app-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
  export default {
    computed:{
      posts(){
          return this.$store.getters['posts/getAllPosts'];
      }
    },
    methods:{
      getFormatDate : function (date) {
        return moment(date, 'YYYY-MM-DD').format('MMMM Do, YYYY');
      },
      loadMore(){
        this.$store.dispatch('posts/getAllPosts', {
          limit: this.posts.length + 3
        })
      }
    },
    created(){
      this.$store.dispatch('posts/getAllPosts', {
        limit: 3 
      })
    }
  };
</script>